import * as React from "react";
import PolicyTable from "../List/PolicyTable";
import { DataContext } from "../../App";
import { Button } from "@progress/kendo-react-buttons";
import { useHistory } from "react-router-dom";
import { onRequestOffer } from "../../Utils/requestOffer";
import "./Views.css"


const ParsePoliciesByStatus = (policies) => {
	const InComparative = [];
	const inResume = [];
	policies.forEach((policy) => {
		if(policy.favorite){
			InComparative.unshift(policy)
		}else if (policy.view_status == "Recomendada" || policy.view_status == 1) {
			InComparative.push(policy);
		} else if (policy.view_status == "Visible" || policy.view_status == 2) {
			inResume.push(policy);
		}
	});
	return [[...InComparative,...inResume], []];
};


export default function PoliciesComparative() {
	const { context, setContext } = React.useContext(DataContext);
	const ParsedPolicies = ParsePoliciesByStatus(context.policy_selected || []);
	const RiskIn = context.oportunity.risk_in;
	const [toPrint, setToPrint] = React.useState(true);
	const [policiesComparative, setPoliciesComparative] = React.useState(
		ParsedPolicies[0]
	);
	const [policiesResume, setPoliciesResume] = React.useState(ParsedPolicies[1]);
	const history = useHistory();

	const toHome = () => {
		history.goBack();
	}

	return (
		<React.Fragment>
			<div  className="wrapper" id="ComparePage" style={{maxWidth:"100%",marginRight:"auto",marginLeft:"auto"}}>
				{policiesComparative.length > 0 || policiesResume.length >0? (
					<React.Fragment>
						{
							policiesComparative.length > 0 ?
								<PolicyTable
									toPrint={toPrint}
									data={{ policy_list: policiesComparative }}
									origin="comparative"
								/>
							: null
						}
						{/* <PolicyDetailsHorizontal data={{ policy_list: policiesResume }} /> */}
					</React.Fragment>
				) : null}
				{/* Espacio para que los botones no molesten */}
				<div style={{height:"5em", display:"block"}}></div>
				<Button onClick={toHome} className="btn-compare mt-2 mb-2 mx-auto sec-button nav-button">
					Volver
				</Button>
			</div>
		</React.Fragment>
	);
}

export function PolicyDetails() {
	const history = useHistory();	
	const { context } = React.useContext(DataContext);
	const [policies,] = React.useState(context.policy_detail || []);
	const toHome = () => {
		history.goBack();
	}

	return (
		<div className="wrapper" id="ProductPage" style={{maxWidth:"100%",marginRight:"auto",marginLeft:"auto"}}>
			<PolicyTable data={{ policy_list: policies}} origin="ver mas" />
			{/* Espacio para que los botones no molesten */}
			<div style={{height:"5em", display:"block"}}></div>
			<div className="d-flex">
				{! policies[0].favorite && 
				<Button onClick={() =>{onRequestOffer(context, policies[0].id_db)}} className="btn-buy sec-button nav-button">
					Solicitar
				</Button>}
				<Button onClick={toHome} className="btn-compare mt-2 mb-2 mx-auto sec-button nav-button">
					Volver
				</Button>
			</div>


		</div>
	);
}